var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFunnelDescription(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 182,
    viewBox: "0 0 128 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.0025 82.7433H60.0017L64.0021 173.462L72.0025 181.437V82.7433Z",
    fill: "#2AA175"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0013 82.7433V165.486L64.0021 173.462V82.7433H56.0013Z",
    fill: "#4FC297"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128 0H112L64.0022 70.7802V90.7184H72.0026L128 0Z",
    fill: "#2AA175"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33955e-07 0L56.0013 90.7184H64.0021L111.999 0H4.33955e-07Z",
    fill: "#4FC297"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelDescription);
export default __webpack_public_path__ + "static/media/funnel-description.a934d309b9b6314e35df8e9db9945bd3.svg";
export { ForwardRef as ReactComponent };